import { Route, Routes } from 'react-router';

import ClaimsDetail from './Detail';
import ClaimsOverview from './Overview';

export default function InvoicesRoutes() {
  return (
    <Routes>
      <Route index element={<ClaimsOverview />} />
      <Route path="/:id" element={<ClaimsDetail />} />
    </Routes>
  );
}
